import React, { useEffect, useMemo, useState } from 'react';
import { useTenantContext } from '../../context/TenantContext';
import { PublicFooter } from '../layout/PublicFooter';

// Chargement dynamique des templates de pied de page
const footerModules = import.meta.glob('/src/templates/footers/**/*.{tsx,jsx,ts,js}');

export const FooterSlot: React.FC = () => {
  const { tenant } = useTenantContext();

  const selectedPath = useMemo(() => {
    const templates = (tenant?.config?.templates || {}) as any;
    const footers = (templates.footers || {}) as Record<string, string>;
    const path = footers.default || '';
    
    // Debug: Afficher les informations de chargement du footer
    console.log('🦶 FooterSlot - Tenant:', tenant?.name);
    console.log('🦶 FooterSlot - Selected Path:', path);
    console.log('🦶 FooterSlot - Available modules:', Object.keys(footerModules));
    
    return path;
  }, [tenant]);

  const [FooterComponent, setFooterComponent] = useState<React.ComponentType | null>(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [tenantLoading, setTenantLoading] = useState(!tenant);

  // Suivre le chargement du tenant
  useEffect(() => {
    setTenantLoading(!tenant);
  }, [tenant]);

  useEffect(() => {
    let mounted = true;
    if (selectedPath && footerModules[selectedPath]) {
      setLoadingTemplate(true);
      const loader = footerModules[selectedPath] as () => Promise<{ default: React.ComponentType }>;
      loader()
        .then((mod) => {
          if (mounted) setFooterComponent(() => mod.default);
        })
        .catch((err) => {
          console.error('Erreur de chargement du footer template:', err);
          if (mounted) setFooterComponent(null);
        })
        .finally(() => mounted && setLoadingTemplate(false));
    } else {
      setFooterComponent(null);
      setLoadingTemplate(false);
    }
    return () => {
      mounted = false;
    };
  }, [selectedPath]);

  // Pendant le chargement du tenant ou du template, ne rien afficher (éviter le flash)
  if (tenantLoading || loadingTemplate) return null;
  if (FooterComponent) return <FooterComponent />;
  return <PublicFooter />;
};
